/*

FILE: events.js
DESCRIPTION: Handle events throughout site
AUTHOR(S): R.J. LaCount

*/

import { elements } from './elements';
import { linkClicked, showTriggerClicked } from './links';
import { closeMobileNav, toggleMobileNav } from './nav';
import { initOnResize, initOnVisibilityChange } from '../app.main';
import { openBioModal, closeBioModal } from './modals';
import { scrollToEl } from './scroll';
import { loadMore } from './dom';

const clickHandlers = (e) => {
	const target = e.target;

	if (Array.from(elements.links).includes(target)) linkClicked(e);
	if (Array.from(elements.showTriggers).includes(target)) showTriggerClicked(e);
	if (elements.mobileNavToggle === target) toggleMobileNav(e);
	if (Array.from(elements.bioModalTriggers).includes(target)) openBioModal(e);
	if (Array.from(elements.modalClose).includes(target)) closeBioModal(e);
	if (elements.modalOverlayClose === target) closeBioModal(e);
	if (Array.from(elements.scrollTriggers).includes(target)) scrollToEl(target);
	if (Array.from(elements.loadMoreTriggers).includes(target)) loadMore(target);
}

const resizeHandlers = (e) => {
	initOnResize();
	// get width
	const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	if (width >= 1024) {
		closeMobileNav();
	}
}

const visibilityChangeHandlers = (e) => {
	initOnVisibilityChange();
}

const setEventHandlers = () => {
	document.addEventListener('click', clickHandlers);
	window.addEventListener('resize', resizeHandlers);
	document.addEventListener('visibilitychange', visibilityChangeHandlers);
}

const removeEventHandlers = () => {
	document.removeEventListener('click', clickHandlers);
	window.removeEventListener('resize', resizeHandlers);
	document.removeEventListener('visibilitychange', visibilityChangeHandlers);
}

export { setEventHandlers, removeEventHandlers };
